module.exports = {"domain":"beathey.us.auth0.com","clientId":"jWl5vEKTpjMG3DVmEdElMvbmIHguQan9"}


//////////////////
// WEBPACK FOOTER
// ./src/auth_config.json
// module id = 1308
// module chunks = 4